import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import LegalModel from './model/LegalModel';
import i18n from '@launchpad/i18n';
import { Trans } from 'react-i18next';

export default class PrivacyPolicy extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      privacy: null,
      loading: true
    };
  }

  componentDidMount() {
    new LegalModel().getPrivacy().then(privacy => {
      this.setState({
        privacy,
        loading: false
      });
      if (privacy.text === '') {
        this.setState({
          loading: true
        });
      }
    });
  }

  render() {
    const content =
      this.state.privacy && this.state.privacy.data
        ? this.state.privacy.data.text
        : null;
    let contentElement = null;
    if (content) {
      contentElement = this.state.privacy.data.text;
    }
    return (
      <div className="appContainer">
        <h1 className="legal-title">
          <Trans>Privacy Policy</Trans>
        </h1>
        <div className="container">
          <div className="card-wrapper pt-3">
            {this.state.loading ? (
              <CircularProgress className="circle-progress" size={40} />
            ) : (
              <div className="col-12 white-box no-shadow">
                <div
                  className="legal-description cms-content"
                  style={{ background: 'transparent', paddingTop: 0 }}
                  dangerouslySetInnerHTML={{ __html: i18n.t(contentElement) }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
